var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifestyleTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.61 10.71A6.56 6.56 0 0 1 13.33 9a4.2 4.2 0 0 1 2.75 1.25.33.33 0 1 0 .48-.45 5.44 5.44 0 0 0-2.11-1.54c4.23-2.13 2.75-8.44-2-8.21C6 .48 6.13 6.91 9.44 8.4a6.37 6.37 0 0 0-2.31 2 .29.29 0 0 0 .48.31Zm.73-4.6c-.75-2.56.69-4.8 4.23-5 3.73-.3 5.05 5.18.86 6.82A5.89 5.89 0 0 0 10.5 8a2.73 2.73 0 0 1-2.16-1.89Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.55 5.07c-.46 0-.09.53-.93.78a1.37 1.37 0 0 1-1.48-.62c-.35-.53-1-.15-.18 1.19a1.73 1.73 0 0 0 2.68-.13c.43-.55.49-1.29-.09-1.22Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.46 4c.41 0 .41-.52.23-.91-.31-.66-1.45-.67-2.11-.16-1 .76-.69 1.67-.3 1.63a1.36 1.36 0 0 1 1-1.13c1.07-.43.6.57 1.18.57Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.35 3.82c.05 0 .1.08.18.08s.74-.94 1.3-.45c.38.34.22.87.59.87a.33.33 0 0 0 .33-.32 1.32 1.32 0 0 0-2-1.29c-.09.08-.48.47-.51.7s-.03.32.11.41Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.13 11.36c-.12-1-.6-1.37-1.38-1.33s-1.33.25-7.59 2.1a6.27 6.27 0 0 1-2.34.52c-2.32-.37-4.55-1-6.93-1.34-1.2-.18-3-.77-3.33-.46a.33.33 0 0 0 .32.57s.1 0 .16 0c.58.07 9.32 2 9.66 2.06a48.69 48.69 0 0 0-.29 8.88.33.33 0 1 0 .66 0 41.17 41.17 0 0 0 .28-8.87c.94-.07 8.72-2.56 9.65-2.43a8.88 8.88 0 0 1 0 2.3c-.16 5.1.18 5.75-.72 6.21A99.33 99.33 0 0 1 11.69 23a54.87 54.87 0 0 1-8.14-2.13 10.09 10.09 0 0 1-1.72-.94 3.78 3.78 0 0 1-.24-1.45c0-.36-.16 1.51.29-6.5a.29.29 0 0 0-.58 0c-.41 5.39-.65 7-.18 8.23.15.39.7.59 1 .79A16.5 16.5 0 0 0 6 22.53 37 37 0 0 0 11.64 24c.36.06 10.18-2.94 10.91-4s.5-3.38.5-4.56c.01-.27.11-3.77.08-4.08Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87 14.24c.14-.65-2.52-1.33-2.71-.83 0 .09-.11.18 0 .3.14.4 2.71 1.35 2.71.53Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49 16.25c.14-.64-2.52-1.33-2.71-.83 0 .09-.11.19 0 .3.14.4 2.71 1.35 2.71.53Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49 19.18c.14-.64-2.52-1.33-2.71-.83 0 .09-.11.19 0 .3.14.4 2.71 1.35 2.71.53Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63 20.36c.15-.64-2.52-1.32-2.7-.83 0 .09-.12.19 0 .3.13.4 2.7 1.35 2.7.53Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7 15Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.61 15.12a1.63 1.63 0 0 0 0-.48c-.25-.74-1.28-.29-2-.34-1.47-.11-1.38.09-1.62 1.33-.11.52-.61 1.23-.25 1.82a5 5 0 0 0 3.43.41.78.78 0 0 0 .38-.51 12.51 12.51 0 0 0 .06-2.23Zm-1 1.78c-.39.09-1.58-.09-2 0a2.22 2.22 0 0 0 .09-1.79 1.86 1.86 0 0 1 .81 0 10 10 0 0 0 1.13 0l-.13 1.26c-.01.05.07.34.07.53Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.14 16.69a.64.64 0 0 0 .48.53c.78.22 7-1.6 7.48-2.07a1.19 1.19 0 0 0 .24-.78 10.94 10.94 0 0 0-.19-1.76c-.24-.94-1.48-.18-6.19 1.13-.12 0-.64.12-.85.19-1.17.4-.86.64-.88 1.47-.02.08-.11 1.2-.09 1.29Zm1-2.07c.46 0 4.41-1 6-1.33a8.55 8.55 0 0 1 .05 1.1c-6 2-6.09 2.09-6.32 2.1.25-.28-.38-1.87.26-1.87Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.37 18c-4 .91-3.64 1.07-3.63 1.2a.29.29 0 0 0 .31.27c2.05.24 2.1-.2 3.48-.83a.33.33 0 0 0-.16-.64Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.77 17.77c0 .41.9.55 1.44.25s.61-.36.66-.44.05-.37 0-.47c-.2-.62-2.08.31-2.1.66Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifestyleTips);
export default __webpack_public_path__ + "static/media/lifestyle-tips.154486a624cd971af3c7a7a351dd0323.svg";
export { ForwardRef as ReactComponent };